<template>
  <group gutter="0px" class="car_info_item " >
    <swiper :list="images" height="6.66667rem" imgKey="image_url" @on-click-list-item="clickListItem" class="previewer-demo-img">
    </swiper>
    <cell class="car_info">
      <div slot="after-title" class="car_info_detail">
        <p class="title">{{carInfo.car_model_name}}</p>
        <p>{{carInfo.plate_number}}<i class="block">|</i>{{carInfo.license_issued_on}}<i class="block">|</i>{{carInfo.mileage}}<i class="block">|</i>{{carInfo.emission_standard_name}}</p>
        <p v-if="minimumPrice">起拍价：{{(minimumPrice / 1000000).toFixed(2)}}万元</p>
      </div>
    </cell>
  </group>
</template>
<script>
import {
  Group,
  Cell,
  Swiper
} from '@lx-frontend/cvux'
export default {
  components: {
    Group,
    Cell,
    Swiper
  },
  props: {
    minimumPrice: {
      type: Number,
      default: 0
    },
    images: {
      type: Array,
      default() {
        return []
      },
      required: true
    },
    carInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    clickListItem(item) {
      this.$emit('click-swiper', item)
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
.car_info_item {
  .weui_cells_title {
    opacity: 1;
  }
  .weui_cells:after {
    display: none;
  }
  .car_info {
    background: #f0f0f0;
    padding: 30/@w2;
    margin: -20/@w2 30/@w2 0;
    border-bottom: 1px solid #bdbdc5;
    .radius(8/@w2);
    .car_info_detail {
      color: #5d5d5d;
      font-size: 26/@w2;
      line-height: 1.6;
      .title {
        font-size: 30/@w2;
        color: #000;
      }
      .block{padding: 0 10/@w2;}
    }
    &:before {
      display: none;
    }
  }
}

</style>
